import {
  SET_TEMPLATE_ID,
  SET_IS_CUSTOM_TEMPLATE_PUBLISHED,
} from './customTemplateActionTypes';
import type { EditorState } from '#packages/stateManagement';
import type { Dispatch, DispatchMapperArgs } from 'types/redux';
import { ErrorReporter } from '@wix/editor-error-reporter';
import * as util from '#packages/util';
import constants from '#packages/constants';
import { getCustomTemplateId } from './customTemplateSelectors';

export const setTemplateId = (templateId: string) => ({
  type: SET_TEMPLATE_ID,
  templateId,
});

export const setIsCustomTemplatePublished = (
  isCustomTemplatePublished: boolean,
) => ({
  type: SET_IS_CUSTOM_TEMPLATE_PUBLISHED,
  isCustomTemplatePublished,
});

export const publishTemplate =
  () =>
  async (
    dispatch: Dispatch,
    getState: () => EditorState,
    { editorAPI }: DispatchMapperArgs,
  ) => {
    const origin = location.origin;
    const url = `${origin}/_serverless/wix-studio-templates-proxy/publishTemplate`;

    try {
      const templateId = getCustomTemplateId(getState());
      const publishResponse = await util.http
        .fetch(url, {
          headers: new Headers({
            Authorization: editorAPI.dsRead.platform.getAppDataByApplicationId(
              constants.APPLICATIONS.META_SITE_APPLICATION_ID,
            )?.instance,
            'Content-Type': 'application/json',
          }),
          method: 'POST',
          body: JSON.stringify({
            templateId,
          }),
        })
        .then((response) => response.json());

      dispatch(setIsCustomTemplatePublished(publishResponse.published));
    } catch (e) {
      ErrorReporter.captureException(e);
      throw e;
    }
  };

export const fetchTemplateData =
  () =>
  async (
    dispatch: Dispatch,
    getState: () => EditorState,
    { dsRead, editorAPI }: DispatchMapperArgs,
  ) => {
    const metaSiteId = dsRead.generalInfo.getMetaSiteId();
    const origin = location.origin;
    const url = `${origin}/_serverless/wix-studio-templates-proxy/findTemplateByMetaSiteId/${metaSiteId}`;

    try {
      const templateData = await util.http
        .fetch(url, {
          headers: new Headers({
            Authorization: editorAPI.dsRead.platform.getAppDataByApplicationId(
              constants.APPLICATIONS.META_SITE_APPLICATION_ID,
            )?.instance,
          }),
          method: 'GET',
        })
        .then((response) => response.json());

      dispatch(setTemplateId(templateData.id));
      dispatch(setIsCustomTemplatePublished(templateData.published));
    } catch (e) {
      ErrorReporter.captureException(e);
      throw e;
    }
  };
